import routerOptions0 from "/home/runner/work/vaneerd-werkenbij/vaneerd-werkenbij/website/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}